export const REJECT_ACTION_TYPE = ['return'];

export const CUSTOM_ACTION_TYPE = [
  'system_booking_hook',
  'system_booking_approve',
  'system_booking_trip_create',
  'system_booking_trip_info',
  'system_booking_trip_change',
  'system_booking_trip_ordering',
  'system_booking_limits_exceeded_approve',
  'system_booking_trip_limit_approved',
  'system_booking_trip_cancel',
  'system_create_request_sw',
  'system_item_voucher_sw',
  'system_trip_info_sw',
  'system_cancel_request_sw',
  'system_business_trip_file_delivery',
  'system_linkedtrip_attrinfo',
  'system_linkedtrip_approveinfo',
];
